<template>
  <div class="topRouge" id="reseauxPersonnalise">
    <p class="p_size18 has-text-weight-bold has-text-link bottomVert">
      <b-icon
        icon="circle"
        size="is-small"
        class="circleStyleMobile">
      </b-icon>
      Proposition réseau(x) personnalisé(s)
    </p>
    <div class="colomn"
      v-for="(reseauxPersonnalise, index) in detailReseauxPersonnalise"
      :key="index">
      <h3 class="has-text-default has-text-weight-bold topBleu bottomVert">
        {{reseauxPersonnalise.libelle}}
      </h3>
      <app-carte-reseaux-personnalise
        :faces="reseauxPersonnalise.faces"
        :couleur="reseauxPersonnalise.couleur"/>
      <app-info-reseaux-personnalise :infoReseauxPersonnalise="reseauxPersonnalise"/>
    </div>
  </div>
</template>

<script>
import infoReseauxPersonnalise from './infoReseauxPersonnalise';
import carteReseauxPersonnalise from './carteReseauxPersonnalise';

export default {
  name: 'index',
  props: ['detailReseauxPersonnalise'],
  components: {
    appInfoReseauxPersonnalise: infoReseauxPersonnalise,
    appCarteReseauxPersonnalise: carteReseauxPersonnalise,
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxPersonnalise/index.vue